import React from 'react'

function ActivityBars() {
  return (
    <div className="flex items-end gap-1.5">
      {[0, 1, 2, 3, 4].map((index) => (
        <span
          key={index}
          className="activity-bar"
          style={{ animationDelay: `${index * 120}ms` }}
        />
      ))}
    </div>
  )
}

export default function AnimatedInputOverlay({
  active = false,
  title = 'Working…',
  subtitle = 'Please wait while we process your request.',
  roundedClassName = 'rounded-2xl',
}) {
  if (!active) return null

  return (
    <div className={`pointer-events-none absolute inset-0 z-20 overflow-hidden border border-violet-200/70 bg-white/88 backdrop-blur-sm ${roundedClassName}`}>
      <div className="input-activity-gradient absolute inset-0" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.78),transparent_38%),radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.78),transparent_34%)]" />
      <div className="relative flex h-full w-full flex-col items-center justify-center gap-3 px-4 text-center">
        <ActivityBars />
        <div>
          <div className="text-sm font-semibold text-slate-800">{title}</div>
          <div className="mt-1 text-xs text-slate-500">{subtitle}</div>
        </div>
      </div>
    </div>
  )
}
